<template>
  <el-row>
  <header class="header">
      <img src="../assets/zf-logo.png" width="100">
      <h1>中国房地产测评系列榜单后台</h1>
    </header>
    <div>
      <a href="/#/admin/list">返回列表</a>
    </div>
    <div class="main">
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <h3>{{award.name}}</h3>
          <el-tag type="danger" v-if="award.publishdate != null">发布时间已设置为：{{dateFormat(award.publishdate)}}</el-tag>
          <div style="width:100%;margin:0 auto;margin-bottom:10px;">
            <el-row :span="24">
              <!-- <el-col :span="4">
                <h3>{{award.name}}</h3>
              </el-col> -->
              <el-col :span="6">
                <div style="margin-top:14px;">
                <el-date-picker
                  v-model="listyear"
                  align="right"
                  type="year">
                </el-date-picker>
                </div>
              </el-col>
              <el-col :span="6">
                <div style="margin-top:14px;">
                <!-- <el-cascader
                  placeholder="子榜单"
                  :options="subnameOptions"
                  @change="getThisAwardsId"
                  :props="props"
                  :clearable="true"
                  change-on-select
                  :disabled="subnameOptions.length == 0">
                </el-cascader> -->
                <el-cascader placeholder="子榜单"
                  v-model="selectedOptions"
                  :options="subnameOptions"
                  @change = "getaaa"
                  :props="props"
                  :clearable="true"
                  change-on-select
                  :disabled="subnameOptions.length == 0">
                </el-cascader>  
                </div>
              </el-col>
              <el-col :span="12">
                <div style="margin-top:14px;">
                <el-button-group>
                  <el-button type="primary" @click="showdialogFormSetAwards">设置</el-button>
                  <el-button type="primary" @click="dialogFormAddData = true">数据导入</el-button>
                  <el-button type="primary" @click="dialogFormPublishDate = true ">设置发布时间</el-button>
                  <el-button type="danger" icon="delete" @click="deleteAll">删除数据</el-button>
                </el-button-group>
                </div>
              </el-col>
            </el-row>
            
          </div>
          <el-dialog title="设置发布时间" :visible.sync="dialogFormPublishDate">
            <el-form :model="formSetAwards">
              <el-date-picker
                  v-model="publishdate"
                  align="right"
                  type="datetime"
                  placeholder="请选择年份">
                </el-date-picker>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="setPublishDate(formSetAwards.id, publishdate)">确定</el-button>
            </div>
          </el-dialog>
          <el-dialog title="奖项设置" :visible.sync="dialogFormSetAwards">
            <el-form :model="formSetAwards">
              <el-form-item label="获奖名称" :label-width="formLabelWidth">
                <el-col :span="20">
                <el-input v-model="formSetAwards.name" auto-complete="off"></el-input>
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" @click="updateSub(formSetAwards.id, formSetAwards)">保存</el-button>
                </el-col>
              </el-form-item>
              <el-form-item label="所属年份" :label-width="formLabelWidth">
                <el-col :span="20">
                  <el-input v-model="formSetAwards.mark"></el-input>
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" @click="updateSub(formSetAwards.id, formSetAwards)">保存</el-button>
                </el-col>
              </el-form-item>
              <el-form-item label="添加分类" :label-width="formLabelWidth">
                <el-col :span="20">
                  <el-input v-model="formSetAwards.subname" placeholder="请输入分类名称"></el-input>
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" @click="saveSub">添加</el-button>
                </el-col>
              </el-form-item>
              <el-form-item label="子榜单" v-if="formSetAwards.issub" :label-width="formLabelWidth">
                <el-table :data="awardsSubList" border style="width: 100%">
                    <el-table-column type="index" width="80">
                    </el-table-column>
                    <el-table-column label="排序" width="80">
                        <template scope="scope">
                            <el-input size="small" v-model="scope.row.sort"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="榜单分类名称">
                        <template scope="scope">
                          <el-input size="small" v-model="scope.row.name"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template scope="scope">
                          <el-button type="text" @click="tmpdaoru(scope.row.id)" size="small">导入数据</el-button>
                          <el-button type="text" @click="updateSub(scope.row.id, scope.row)" size="small">保存</el-button>
                          <el-button type="text" @click="deleteSub(scope.row.id)" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogFormSetAwards = false">关 闭</el-button>
            </div>
          </el-dialog>

          <el-dialog title="数据导入" :visible.sync="dialogFormAddData">
            <el-form :model="formAddData">
              <el-form-item label="年份" :label-width="formLabelWidth">
                <el-date-picker
                  v-model="year"
                  align="right"
                  type="year"
                  placeholder="请选择">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="上传文件" :label-width="formLabelWidth">
                <!-- <input type="file" @change="csvfileChange"/> -->
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  action="/"
                  :on-change="fileChange"
                  :file-list="fileList"
                  accept=".csv"
                  :auto-upload="false">
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <span style="margin-left:10px;" slot="tip" class="el-upload__tip">只能选取csv格式文件</span>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormAddData = false">取 消</el-button>
              <el-button type="primary" @click="daoru">导入</el-button>
            </div>
          </el-dialog>
          <el-table :data="tableData" border class="result-list-table" @selection-change="handleSelectionChange">
            <el-table-column type="selection"></el-table-column>
            <el-table-column prop="year" align="left" label="年份">
            </el-table-column>
            <el-table-column prop="awardsorder" key="1" align="left" label="排名" v-if="hasValue('awardsorder',tableData)">
            </el-table-column>
            <el-table-column prop="qname" key="2" align="left" label="企业名称" v-if="this.award.id != 2"> 
              <template scope="scope">
                {{scope.row.qname}}
              </template>
            </el-table-column>
            <el-table-column prop="qname"  key="2"  align="left" label="企业名称" v-else-if="this.year < 2021">
                <template scope="scope">
                  {{scope.row.qname}}
                </template>
            </el-table-column>
            <el-table-column prop="lname" key="3"  align="left" label="证券简称" v-if="hasValue('lname', tableData)">
              <template scope="scope">
                {{scope.row.lname}}
              </template>
              </el-table-column>
            <el-table-column prop="lcode" key="4" align="left" label="证券代码" v-if="hasValue('lcode', tableData)">
              <template scope="scope">
                {{scope.row.lcode}}
              </template>
            </el-table-column>
            <el-table-column prop="projectname" key="5" align="left" label="项目名称" v-if="hasValue('projectname', tableData)">
            </el-table-column>
            <el-table-column prop="brandname" key="6" align="left" label="品牌名称" v-if="hasValue('brandname', tableData)">
            </el-table-column>
            <el-table-column prop="firstbrandrate" key="7" align="left" label="首选品牌率" v-if="hasValue('firstbrandrate', tableData)">
            </el-table-column>
            <el-table-column prop="brandvalue" key="8" align="left" label="品牌价值（亿元)" v-if="hasValue('brandvalue', tableData)">
            </el-table-column>
            <el-table-column prop="awardsname" key="9" align="left" label="奖项名称" v-if="hasValue('awardsname', tableData)">
              <template scope="scope">
                {{scope.row.awardsname}}
              </template>
            </el-table-column>
            <el-table-column prop="subindustry" key="10" align="left" label="子产业" v-if="hasValue('subindustry', tableData)">
              <template scope="scope">
                {{scope.row.subindustry}}
              </template>
            </el-table-column>
            <el-table-column prop="professionalfield" key="11" align="left" label="专业领域/行业领域" v-if="hasValue('professionalfield', tableData)">
              <template scope="scope">
                {{scope.row.professionalfield}}
              </template>
            </el-table-column>
            <el-table-column prop="sort" align="left" key="12" label="排序" v-if="hasValue('sort',tableData)">
            </el-table-column>
            <el-table-column label="操作">
              <template scope="scope">
                <el-button
                  size="small"
                  @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog title="编辑" :visible.sync="dialogFormEditRow">
            <el-form :model="editRow">
              <el-form-item label="年份" :label-width="'160px'">
                <el-col :span="20">
                <el-date-picker
                  v-model="editRow.year"
                  align="right"
                  type="year"
                  placeholder="请选择">
                </el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="排名" :label-width="'160px'" v-if="editRow.awardsorder != null">
                <el-col :span="20">
                <el-input v-model="editRow.awardsorder" auto-complete="off"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="企业名称" :label-width="'160px'" v-if="editRow.qname != null">
                <el-col :span="20">
                <el-input v-model="editRow.qname" auto-complete="off"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="证券简称" :label-width="'160px'" v-if="editRow.lname != null">
                <el-col :span="20">
                <el-input v-model="editRow.lname" auto-complete="off"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="证券代码" :label-width="'160px'" v-if="editRow.lcode != null">
                <el-col :span="20">
                <el-input v-model="editRow.lcode" auto-complete="off"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="项目名称" :label-width="'160px'" v-if="editRow.projectname != null">
                <el-col :span="20">
                <el-input v-model="editRow.projectname" auto-complete="off"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="品牌名称" :label-width="'160px'" v-if="editRow.brandname != null">
                <el-col :span="20">
                <el-input v-model="editRow.brandname" auto-complete="off"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="首选品牌率" :label-width="'160px'" v-if="editRow.firstbrandrate != null">
                <el-col :span="20">
                <el-input v-model="editRow.firstbrandrate" auto-complete="off"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="品牌价值（亿元)" :label-width="'160px'" v-if="editRow.brandvalue != null">
                <el-col :span="20">
                <el-input v-model="editRow.brandvalue" auto-complete="off"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="奖项名称" :label-width="'160px'" v-if="editRow.awardsname != null">
                <el-col :span="20">
                <el-input v-model="editRow.awardsname" auto-complete="off"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="子产业" :label-width="'160px'" v-if="editRow.subindustry != null">
                <el-col :span="20">
                <el-input v-model="editRow.subindustry" auto-complete="off"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="专业领域/行业领域" :label-width="'160px'" v-if="editRow.professionalfield != null">
                <el-col :span="20">
                <el-input v-model="editRow.professionalfield" auto-complete="off"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="排序" :label-width="'160px'" v-if="editRow.sort != null">
                <el-col :span="20">
                <el-input v-model="editRow.sort" auto-complete="off"></el-input>
                </el-col>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormEditRow = false">取 消</el-button>
              <el-button type="primary" @click="saveThisRow">保存</el-button>
            </div>
          </el-dialog>
        </div>
        <div>
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-sizes="[25, 50, 100, 200]"
              :page-size="countPerPage"
              layout="total, sizes, prev, pager, next"
              :total="total">
          </el-pagination>
        </div>
      </el-col>
    </div>
  </el-row>
</template>
<script>
function getOptionsKey(value, arrObj){
  var key = 0;
  for(var v in arrObj){
    if(arrObj[v].value == value){
      key = v;
    }
  }
  return key;
};

function getData(thisObj, awardId){
  var year; 
  if(thisObj.listyear != ''){
    year = new Date(thisObj.listyear);
    year = year.getFullYear();
    year = year.toString();
    var w = {awardId: awardId, year: year};
  }else{
    var w = {awardId:awardId};
  }
  var paramsObj = {   
        params : {
              where: w, 
              countPerPage: thisObj.countPerPage, 
              currentPage: thisObj.currentPage
        }
      };
    thisObj.$http.get('api/awards/getcompany', paramsObj).then(
      response => {
          thisObj.tableData = response.body.listArr;
          thisObj.total = response.body.count;
        },
      response => {
          console.log('failed');
      }
    );
};

function getThisAward(thisObj, id){
  thisObj.$http.get('/api/awards/getawardsdetail',{params: {id: id}}).then(    // 本奖项上级奖项明细
    response => {
      var d = response.body;
      thisObj.formSetAwards = d.award;
    },
    response => {
      console.log('failed');
    }
  );
};

function getThisSub(thisObj,id){
  thisObj.$http.get('api/search/get_awards_sublist', {params: {preId: id, year: thisObj.year}}).then( //获取下一级奖项
    response => {
       var sublist = response.body;
        thisObj.awardsSubList = sublist;
        thisObj.subnameOptions = sublist.map(item => {
          if(!item.issub){
            return {label: item.name, value: item.id, children:null};
          }else{
            return {label: item.name, value: item.id, children:[]};
          }
        });
      console.log(response.body);
    }
  )
};

function _mapOptions(_id, _thisSubOption, _thisObj){
  _thisObj.$http.get('api/search/get_awards_sublist',{params: {preId: _id, year:_thisObj.year}}).then(
    response => {
      var k = getOptionsKey(_id, _thisSubOption.children); //此级分类在当前数组中的位置
      var nextSubOption = _thisSubOption.children[k];
      nextSubOption.children = response.body.map(item=>{
        return {label:item.name, value:item.id, children:null};
      });
    }
  )
}

function _subOptionsConfig(_preId, _subnameOptions, _thisObj){
      var that = _thisObj;
      var k = getOptionsKey(_preId, _subnameOptions);
      var thisSubOption = _subnameOptions[k];
      _thisObj.$http.get('api/search/get_awards_sublist',{params: {preId: _preId, year: that.year}}).then(
        response =>{
          var sublist = response.body;
          var tmparr = [];
          sublist.forEach(function(element){
            var tmpopt = {label:element.name, value:element.id,children:null};
            tmparr.push(tmpopt);
            thisSubOption.children = tmparr;
            var k = getOptionsKey(element.id, thisSubOption); //此级分类在当前数组中的位置
            var nextSubOption = thisSubOption.children[k];
            if(element.issub){
              _mapOptions(element.id, nextSubOption, _thisObj);
            }
          },this);
        },
        response => {
          console.log('failed');
        }
      )
};


export default {
  name: 'adminsublist',
  data () {
   return {
      msg: '',
      idArr: [],
      firstIdArr: [],
      subnameOptions:[],
      selectedOptions:[],
      tableData: [],
      data: [],
      award: {
        name: '',
        id: ''
      },
      awardsSubList: [],
      listyear:'',
      total:0,
      countPerPage: 25,
      currentPage: 1,
      props: {
        value: 'value',
        label: 'label',
        children: 'children'
      },
      formSetAwards : {
          id: '',
          name: ''
      },
      year:'',
      formAddData : {
          id: '',
          year: ''
      },
      fileList: [],
      dialogFormAddData: false,
      dialogFormSetAwards: false,
      dialogFormPublishDate: false,
      publishdate:'',
      formLabelWidth: '120px',
      dialogFormEditRow: false,
      editRow:{},
      tmpawardId:'',
      vals:[],
      val:[]
    }
  },

  mounted: function(){
    var d = new Date();
    var that = this;
    this.year = d.getFullYear()
    that.setHeight();
    $(window).resize(function(){
      that.setHeight();
    });
    this.$nextTick(function () {
        var id = this.$route.params.id;
        this.award.id = id;
        getThisAward(this, id);
        this.$http.get('/api/awards/getawardsdetail',{params: {id: this.$route.params.id}}).then(    // 本奖项上级奖项明细
          response => {
            var d = response.body; 
            this.award = d.award;
            this.publishdate = d.award.publishdate;
          },
          response => {
            console.log('failed');
          }
        );
        this.$http.get('api/search/get_awards_sublist', {params: {preId: id, year: this.year}}).then(  //获取下一级奖项   这部分有待二次开发
            response => {
              var sublist = response.body;
              this.awardsSubList = sublist;
              this.subnameOptions = sublist.map(item => {
                if(!item.issub){
                  return {label: item.name, value: item.id, children:null};
                }else{
                  return {label: item.name, value: item.id, children:[]};
                }
              });
            },
            response => {
              console.log('failed');
            }
          );

        getData(this, this.award.id);
        
      });

    },
  watch: {
    listyear: {
      handler:function(val,oldval){
        console.log('listyear');
        var year = (val==undefined) ? new Date() : new Date(val); 
        this.listyear = (val==undefined) ? '' : val.toString();
          year = year.getFullYear();
          year = year.toString();
          this.year = year;
          var id = this.$route.params.id;
          this.award.id = id;
        // getData(this, this.award.id);
        // getThisSub(this,this.award.id);
          getThisAward(this, id);
          this.$http.get('/api/awards/getawardsdetail',{params: {id: this.$route.params.id}}).then(    // 本奖项上级奖项明细
            response => {
              var d = response.body; 
              this.award = d.award;
              this.publishdate = d.award.publishdate;
            },
            response => {
              console.log('failed');
            }
          );
          this.$http.get('api/search/get_awards_sublist', {params: {preId: id, year: this.year}}).then(  //获取下一级奖项   这部分有待二次开发
              response => {
                var sublist = response.body;
                this.awardsSubList = sublist;
                this.subnameOptions = sublist.map(item => {
                  if(!item.issub){
                    return {label: item.name, value: item.id, children:null};
                  }else{
                    return {label: item.name, value: item.id, children:[]};
                  }
                });
              },
              response => {
                console.log('failed');
              }
            );

          getData(this, this.award.id);
      },
      deep:true
    },
    selectedOptions: {
      handler: function(val, oldval){
       console.log('selectedOptions');
       var id = this.$route.params.id;
          this.award.id = id;

      }
    }
  },
  methods: {
    //时间格式化
    dateFormat(date){
        var t=new Date(date);
        var year=t.getFullYear(),
       　　 month=t.getMonth()+1,
       　　 day=t.getDate(),
      　　  hour=t.getHours(),
      　　  min=t.getMinutes(),
      　　  sec=t.getSeconds();
  　　  var newTime=year+'-'+
      　　  (month<10?'0'+month:month)+'-'+
     　　   (day<10?'0'+day:day)+' '+
      　　  (hour<10?'0'+hour:hour)+':'+
      　　  (min<10?'0'+min:min)+':'+
      　　  (sec<10?'0'+sec:sec);
  　　  return newTime;
    },
    setPublishDate(a, b){
      var setValue = {
        id : a,
        publishdate: b
      }
      this.$http.post('api/awards/setPublishDate',setValue).then(
        response => {
          if(response.ok){
            this.$message({
              showClose: true,
              message: '已设置',
              type: 'success'
            })
            this.dialogFormPublishDate = false;
          }
        },
        response => {
          console.log('failed');
        }
      )
    },
    getaaa (val){ 
      var k = getOptionsKey(val[val.length-1], this.subnameOptions); 
      var thisSubOption = this.subnameOptions[k];
      this.$http.get('api/search/get_awards_sublist',{params: {preId: val[val.length-1], year: this.year}}).then(
        response =>{
          var sublist = response.body;
          var tmparr = [];
          if(sublist.length == 0) return;
          sublist.forEach(function(element){
            var tmpopt = {label:element.name, value:element.id,children:null};
            tmparr.push(tmpopt); 
            thisSubOption.children = tmparr;
            if(element.issub){
              _mapOptions(element.id, thisSubOption, this);
            }
          },this);
        },
        response => {
          console.log('failed');
        }
      )

      var awardId = (val[val.length - 1] == undefined) ? this.$route.params.id : val[val.length-1]; 
      this.award.id = awardId;
      this.formSetAwards.id = awardId;
      getThisAward(this, awardId);
      getData(this, awardId);
    },
    getThisAwardsId(val){
      if(val != 0){
        this.$http.get('api/search/get_awards_sublist', {params: {preId: val, year: this.year}}).then(
          response => {
            var k = getOptionsKey(val, this.subnameOptions);
            var sublist = response.body;
            if(sublist.length == 0) return;
            this.subnameOptions[k].children = sublist.map(item => {
              if(!item.issub){
                return {label: item.name, value: item.id};
              }else{
                return {label: item.name, value: item.id, children:[]};
              }
            });
            
          },
          response => {
            console.log('failed');
          }
        )
      }

      var awardId = (val[val.length - 1] == undefined) ? this.$route.params.id : val[val.length-1];
      this.award.id = awardId;
      this.formSetAwards.id = awardId;
      getThisAward(this, awardId);
      getData(this, this.award.id);
    },
    hasValue(strKey,arrObj){  //用于表格里某一列是否显示的判断： 该键值里的值如果有值，isvalue = true，否则 isvalue = false
      var hasvalue = false;  
      for(var v in arrObj){
        if((arrObj[v][strKey] != '') && (arrObj[v][strKey] != 'undefined') && (arrObj[v][strKey] != null)){
          hasvalue = true;
        }else{
          hasvalue = false;
        }
      }
      return hasvalue;
    },
    handleSizeChange (val){
      this.countPerPage = val;
      getData(this, this.award.id);
    },
    handleCurrentChange (val){
      this.currentPage = val;
      getData(this, this.award.id);
    },
    daoru () {
       var year = new Date(this.year);
       year = year.getFullYear();
       year = year.toString();
       this.$http.post('api/awards/insertMore', this.csvValue).then(  //插入多条数据
            response => {
              if(response.ok){
                this.$message({
                      showClose: true,
                      message: '恭喜你，导入' + response.body.length + '条数据',
                      type: 'success'
                    });
                this.tableData = response.body;
                this.dialogFormAddData = false;
                this.tmpawardId = '';
                this.$http.post('api/awards/addtomark', {id: this.award.id, year:year}).then(
                      response => {
                        if(response.ok){
                          console.log(response.bodyText);
                        }
                      }
                );
              }
            },
            response => {
              console.log('failed');
            }
       );
    },
    tmpdaoru(val){
      console.log(val);
      this.tmpawardId = val;
      getThisAward(this, val);
      this.dialogFormAddData = true;
    },
    csvfileChange(e) { //上传csv并插入
      var that = this, year;
      if(that.tmpawardId != ''){
          that.formAddData.awardId = this.tmpawardId;
      }else{
          that.formAddData.awardId = this.formSetAwards.id;
      }
      that.formAddData.aname = this.formSetAwards.name;
      if(this.year != ''){
          year = new Date(this.year);
        }else{
          year = new Date();
        }
      that.formAddData.year = year.getFullYear();
      var fReader = new FileReader();
        fReader.readAsDataURL(e.target.files[0]);
        fReader.onload = function(evt){
          var data = evt.target.result;
            var encoding = checkEncoding( data );
            Papa.parse( e.target.files[0], {
                header: true,
                download: true,
                encoding: encoding,
                complete: function(results) {   // UTF8 \r\n与\n混用时有可能会出问题
                  var res = results.data;
                  var arrRes = [];
                  if( res[ res.length-1 ] == ""){ //去除最后的空行
                    res.pop();
                  }
                  for(var i = 0; i < res.length; i++){
                    arrRes[i] = $.extend(res[i], that.formAddData);
                  }
                  that.csvValue = arrRes;
                }
            });
        }
    },
    fileChange(file, fileList) {
      var that = this, year;
      if(that.tmpawardId != ''){
          that.formAddData.awardId = this.tmpawardId;
      }else{
          that.formAddData.awardId = this.formSetAwards.id;
          that.formAddData.aname = this.formSetAwards.name;
      }
      that.formAddData.aname = this.formSetAwards.name;
      if(this.year != ''){
          year = new Date(this.year);
        }else{
          year = new Date();
        }
      that.formAddData.year = year.getFullYear();
      var fReader = new FileReader();
      fReader.readAsDataURL(file.raw);
      fReader.onload = function(evt){
        var data = evt.target.result;
          var encoding = checkEncoding( data );
          Papa.parse( file.raw, {
              header: true,
              download: true,
              encoding: encoding,
              complete: function(results) {   // UTF8 \r\n与\n混用时有可能会出问题
                var res = results.data;
                console.log(res);
                var arrRes = [];
                if( (res[res.length-1].qname == undefined) || (res[res.length-1].qname == '')){ //去除最后的空行
                  res.pop();
                } console.log(that.formAddData);
                for(var i = 0; i < res.length; i++){
                  arrRes[i] = $.extend(res[i], that.formAddData);
                }
                that.csvValue = arrRes;
              }
          });
      }
    },
    handleEdit(index, row) {
      this.dialogFormEditRow = true;
      this.editRow = row;
    },
    saveThisRow(){
      this.$http.post('api/awards/addcompany', this.editRow).then( //添加获奖企业
        response => {
          if(response.ok){
            this.$message({showClose: true,
              message: response.body,
              type: 'success'
            });
            this.dialogFormEditRow = false;
          }
        }
      )
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deleteAll() {
      if(this.multipleSelection != undefined){
        if(this.multipleSelection.length >= 1){
          this.$http.post('api/awards/deleteAll', this.multipleSelection).then(
            response => {
              if(response.body.count > 0){
                this.$message({
                  showClose: true,
                  message: '成功删除' + response.body.count + '条数据',
                  type: 'success'
                });
                // this.tableData = response.body;
                getData(this, this.formSetAwards.id);
                this.multipleSelection = [];
              }else{
                this.$message({
                  showClose: true,
                  message: '您没有删除任何数据',
                  type: 'info'
                });
              }
              
            }
          )
        }else{
          this.$message({
          showClose: true,
          message: '请选择删除项',
          type: 'warning'
        });
        }
        
      }else{
        this.$message({
          showClose: true,
          message: '请选择删除项',
          type: 'warning'
        });
      }
    },
    showdialogFormSetAwards () {
      this.dialogFormSetAwards = true; 
      getThisSub(this,this.formSetAwards.id);
    },
    saveSub() {
      var y = new Date(this.listyear);
      
        var subObj = {};
            subObj.preId = this.formSetAwards.id;
            subObj.name = this.formSetAwards.subname;
            subObj.mark = y.getFullYear();
            this.formSetAwards.issub = 1; console.log(this.formSetAwards);
        this.$http.post('/api/awards/saveawards', this.formSetAwards).then(
          response => {
            if(response.ok){
              console.log('pre modified success');
            }
          },
          response => {
            console.log(response);
          }
        );    
            
        this.$http.post('/api/awards/addawardssub', subObj).then(   //添加奖项分类
            response => {
               if(response.ok){
                  this.$message({
                    showClose: true,
                    message: '恭喜你，添加成功',
                    type: 'success'
                  });
                  this.awardsSubList.push(response.body.data);
               }
            },
            response => {
               console.log(response);
            }
          );
    },
    updateSub(id, v) {
      this.$http.post('/api/awards/saveawards', v).then(   //修改
          response => {
             if(response.ok){
                this.$message({
                  showClose: true,
                  message: '恭喜你，修改成功',
                  type: 'success'
                });
             }
          },
          response => {
             console.log(response);
          }
        )
    },
    deleteSub(id) {
      const h = this.$createElement;
        this.$msgbox({
          title: '消息',
          message: '此操作将永久删除该奖项及其所有数据, 是否继续?',
          showCancelButton: true,
          type: 'warning',
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
              this.$http.get('/api/awards/deleteOneAwards', {params:{id: id}}).then(
                  response => {
                    setTimeout(() => {
                      if(response.ok){
                          done(); 
                      }
                      instance.confirmButtonLoading = false;
                    }, 2000);
                  },
                  response => {
                    this.$message({
                        showClose: true,
                        type: 'warning',
                        message: '请求超时，请检查数据库连接'
                      });

                    setTimeout(() => {
                      instance.confirmButtonLoading = false;
                    }, 300);
                  }
                );
            } else if (action === 'cancel'){
              this.$message({
                showClose: true,
                type: 'info',
                message: '操作已取消'
              });
              done();
            }
          }
        }).then(action => {
          this.$message({
            showClose: true,
            type: 'info',
            message: '已删除'
          });
        });
    },
    setHeight (){
      var height = window.innerHeight - 370;
      $('.main').css('min-height', height + 'px');
    }
              
  }


}



</script>



// WEBPACK FOOTER //
// src/components/AdminSublist.vue